import { UPLOAD_HIGHWAY_LINE_PDF_API_URL, GET_HIGHWAY_LINE_PDF_API_URL, DELETE_HIGHWAY_LINE_PDF_API_URL } from "../../OpticApiConfig";


// Функция для загрузки PDF Coupling на сервер
export const uploadCablePdf = async (file, cableId, setFileName, setIsFileUploaded, setServerPdfUrls, setUploadMessage, user) => {

  const token = localStorage.getItem('token');
  if (!token) {
      console.log('Ошибка! Токен не найден');
      return;
  }

  setFileName(file.name);
  setIsFileUploaded(true);

  const formData = new FormData();
  formData.append('file', file);
  formData.append('cableId', cableId);
  formData.append('user', user);

  try {
    const response = await fetch(UPLOAD_HIGHWAY_LINE_PDF_API_URL, { // URL для загрузки PDF
      method: 'POST',
      body: formData,
      headers: {
        'Authorization': `Bearer ${token}` 
      }
    });

    const textResult = await response.text();
    try {
      const result = JSON.parse(textResult);
      if (response.ok) {
        setUploadMessage(result.message);

        // После успешной загрузки PDF загружаем обновленный список PDF файлов
        await loadCablePdfFromServer(cableId, setServerPdfUrls, setUploadMessage);
      } else {
        setUploadMessage('Ошибка загрузки PDF файла: ' + result.message);
      }
    } catch (parseError) {
      setUploadMessage('Ошибка загрузки PDF файла: ' + textResult);
    }
  } catch (error) {
    setUploadMessage('Ошибка загрузки PDF файла: ' + error.message);
  }
};

// Функция загрузки PDF с сервера Cable OLD
// export const loadCablePdfFromServer = async (cableId, setServerPdfUrls, setUploadMessage) => {
//   const token = localStorage.getItem('token');
//   if (!token) {
//       console.log('Ошибка! Токен не найден');
//       return;
//   }
//     try {
//       const response = await fetch(`${GET_HIGHWAY_LINE_PDF_API_URL}?cableId=${cableId}`, { 
//         headers: {
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${token}` 
//         }
//       });
  
//       if (!response.ok) {
//         throw new Error('Ошибка при загрузке файлов с сервера.');
//       }
  
//       const pdfList = await response.json();
  
//       if (pdfList.length === 0) {
//         setUploadMessage('Файлов не найдены.');
//         setServerPdfUrls([]);
//         return;
//       }
  
//       const pdfUrls = pdfList.map(pdf => {
//         const url = `data:${pdf.contentType};base64,${pdf.fileContent}`;
//         return { url, fileName: pdf.fileName };
//       });
  
//       setServerPdfUrls(pdfUrls);
//       setUploadMessage('');
//     } catch (error) {
//       setUploadMessage('Ошибка загрузки файлов с сервера: ' + error.message);
//     }
//   };

// Функция загрузки PDF+Foto с сервера Cable NEW
export const loadCablePdfFromServer = async (cableId, setServerFiles, setUploadMessage) => {
  const token = localStorage.getItem('token');
  if (!token) {
    console.log('Ошибка! Токен не найден');
    return;
  }

  try {
    const response = await fetch(`${GET_HIGHWAY_LINE_PDF_API_URL}?cableId=${cableId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error('Ошибка при загрузке файлов с сервера.');
    }

    const fileList = await response.json();

    if (fileList.length === 0) {
      setUploadMessage('Файлы не найдены.');
      setServerFiles([]);
      return;
    }

    const fileUrls = fileList.map(file => {
      return {
        url: file.url, // теперь прямой линк с бэка
        fileName: file.fileName,
        type: file.contentType.startsWith('image/') ? 'image' : 'pdf'
      };
    });

    setServerFiles(fileUrls);
    setUploadMessage('');
  } catch (error) {
    setUploadMessage('Ошибка загрузки файлов с сервера: ' + error.message);
  }
};
// export const loadCablePdfFromServer = async (cableId, setServerFiles, setUploadMessage) => {
//   const token = localStorage.getItem('token');
//   if (!token) {
//     console.log('Ошибка! Токен не найден');
//     return;
//   }

//   try {
//     const response = await fetch(`${GET_HIGHWAY_LINE_PDF_API_URL}?cableId=${cableId}`, {
//       headers: {
//         'Content-Type': 'application/json',
//         'Authorization': `Bearer ${token}`
//       }
//     });

//     if (!response.ok) {
//       throw new Error('Ошибка при загрузке файлов с сервера.');
//     }

//     const fileList = await response.json();

//     if (fileList.length === 0) {
//       setUploadMessage('Файлы не найдены.');
//       setServerFiles([]);
//       return;
//     }

//     const fileUrls = fileList.map(file => {
//       return {
//         url: `data:${file.contentType};base64,${file.fileContent}`,
//         fileName: file.fileName,
//         type: file.contentType.startsWith('image/') ? 'image' : 'pdf'
//       };
//     });

//     setServerFiles(fileUrls);
//     setUploadMessage('');
//   } catch (error) {
//     setUploadMessage('Ошибка загрузки файлов с сервера: ' + error.message);
//   }
// };

    // Функция для удаления pdf cable на сервере
export const deleteCablePdf = async (fileName, cableId, setServerPdfUrls, setUploadMessage) => {
  
  const token = localStorage.getItem('token');
      if (!token) {
          console.log('Ошибка! Токен не найден');
          return;
      }

    try {
      const response = await fetch(`${DELETE_HIGHWAY_LINE_PDF_API_URL}?cableId=${cableId}&fileName=${fileName}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}` 
        }
      });
  
      const result = await response.json();
      if (response.ok) {
        setUploadMessage(result.message);
        // Обновляем список изображений
        await loadCablePdfFromServer(cableId, setServerPdfUrls, setUploadMessage);
      } else {
        setUploadMessage('Ошибка удаления файла: ' + result.message);
      }
    } catch (error) {
      setUploadMessage('Ошибка удаления файла: ' + error.message);
    }
  };


//   // Функция для загрузки фото Coupling на сервер
// export const uploadCouplingImage = async (file, couplingLocationId, setFileName, setIsFileUploaded, setServerImageUrls, setUploadMessage, user) => {
   
//     const token = localStorage.getItem('token');
//       if (!token) {
//           console.log('Ошибка! Токен не найден');
//           return;
//       }

//     setFileName(file.name);
//     setIsFileUploaded(true);
  
//     const formData = new FormData();
//     formData.append('file', file);
//     formData.append('couplingLocationId', couplingLocationId);
//     formData.append('user', user);
  
//     try {
//       const response = await fetch(UPLOAD_GOUPLING_FOTO_API_URL, {
//         method: 'POST',
//         body: formData,
//         headers: {
//           'Authorization': `Bearer ${token}` 
//         }
//       });
  
//       const textResult = await response.text();
//       try {
//         const result = JSON.parse(textResult);
//         if (response.ok) {
//           setUploadMessage(result.message);
  
//           // После успешной загрузки фото загружаем обновленный список изображений
//           await loadCouplingImagesFromServer(couplingLocationId, setServerImageUrls, setUploadMessage);
//         } else {
//           setUploadMessage('Ошибка загрузки файла: ' + result.message);
//         }
//       } catch (parseError) {
//         setUploadMessage('Ошибка загрузки файла: ' + textResult);
//       }
//     } catch (error) {
//       setUploadMessage('Ошибка загрузки файла: ' + error.message);
//     }
//   };


//   // Функция для удаления фото Coupling на сервере
// export const deleteCouplingImage = async (fileName, couplingLocationId, setServerImageUrls, setUploadMessage) => {
  
//   const token = localStorage.getItem('token');
//       if (!token) {
//           console.log('Ошибка! Токен не найден');
//           return;
//       }

//     try {
//       const response = await fetch(`${DELETE_GOUPLING_FOTO_API_URL}?couplingLocationId=${couplingLocationId}&fileName=${fileName}`, {
//         method: 'DELETE',
//         headers: {
//           'Authorization': `Bearer ${token}` 
//         }
//       });
  
//       const result = await response.json();
//       if (response.ok) {
//         setUploadMessage(result.message);
//         // Обновляем список изображений
//         await loadCouplingImagesFromServer(couplingLocationId, setServerImageUrls, setUploadMessage);
//       } else {
//         setUploadMessage('Ошибка удаления файла: ' + result.message);
//       }
//     } catch (error) {
//       setUploadMessage('Ошибка удаления файла: ' + error.message);
//     }
//   };